export const LADE_AUSWAHLWERTE_MODULUNTERRICHT =
  "ladeAuswahlwerteModulunterricht";
